import type { ComponentProps, ReactNode } from 'react';

import { AlertLabel } from '../AlertLabel';
import { cn } from '../cn';
import { General } from '../StrokeIcons';

type InfoBoxProps = Omit<ComponentProps<'div'>, 'title'> & {
  title: string | ReactNode;
  icon?: ReactNode;
  type?: 'warning' | 'error';
};

/**
 * Alert box with a bold title and optional body content BELOW it. AlertLabel
 * itself is a single-row `items-center` flex meant for one-line labels —
 * rendering the title and a paragraph as row siblings put them side by side
 * in misaligned columns, so the body is stacked under the title here instead
 * (icon top-aligned with the title line when there is a body).
 */
export const InfoBox = ({ title, children, type, icon = <General.InfoCircle /> }: InfoBoxProps) => {
  return (
    <AlertLabel type={type ?? 'warning'} icon={icon} className={cn('self-start', children != null && 'items-start')}>
      <div className="flex min-w-0 flex-col gap-1">
        <strong>{title}</strong>
        {children}
      </div>
    </AlertLabel>
  );
};
